/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toPharmaceuticalProps, toPharmaceuticalRequest } from './translator/pharmaceutical'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchPharmaceutical, PostPharmaceutical, GetPharmaceutical, PutPharmaceutical } from '@/infrastructure/network/Monitaro/requests/pharmaceutical'
import { IPharmaceuticalProps } from '@/entities/Pharmaceutical'

export default class Pharmaceutical extends MonitaroGatewayBase {
  async FetchPharmaceutical(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchPharmaceutical(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.pharmaceuticals.map((prop) => toPharmaceuticalProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostPharmaceutical(params: IPharmaceuticalProps) {
    const { pharmaceutical } = await this.apiClient.request(new PostPharmaceutical(toPharmaceuticalRequest(params)))
    return toPharmaceuticalProps(pharmaceutical)
  }

  async GetPharmaceutical(id: string) {
    const { pharmaceutical } = await this.apiClient.request(new GetPharmaceutical(id))
    return toPharmaceuticalProps(pharmaceutical)
  }

  async PutPharmaceutical(id: string, params: IPharmaceuticalProps) {
    const { pharmaceutical } = await this.apiClient.request(new PutPharmaceutical(id, toPharmaceuticalRequest(params)))
    return toPharmaceuticalProps(pharmaceutical)
  }
}
